import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupVendorInvoice } from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

export const ImportsDetailExciseDuty = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"exciseDuty"}>
                <NFLookupProduct fieldName={"productId"} title={t("Product")} />
                <NFLookupVendorInvoice
                    fieldName={"vendorInvoice"}
                    title={t("VendorInvoice")}
                />
                <NFLookupUnit
                    fieldName={"exciseDutyAmount"}
                    title={t("ExciseDutyAmount")}
                />
                <NFLookupAccount
                    fieldName={"exciseAccountId"}
                    title={t("ExciseAccount")}
                />
            </NFormTable>
        </>
    );
};
